import React, { useEffect, useState } from "react";
import { DonutChart } from "@carbon/charts-react";
import "@carbon/charts-react/styles.css";
import "./chart.css";
import axios from "axios";
import { ContentCopy } from "@mui/icons-material";
import ImageLoading from "../../../components/ImageLoading";
import { Tooltip } from "@mui/material";

function DonutChartCarbon() {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);

  const formatCenterValue = (value) => {
    return `₹${indianNumberFormat(value)}`;
  };
  const fetchNetworthGraph = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/spectrum_analysis_graph`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data) setGraphData(res.data);
      setLoading(false);
    } catch (error) {}
  };
  const options = {
    title: null,
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },

    color: {
      scale: {
        Vehicle: "#26aba4", // Blue
        "Mutual Funds": "#f7a452", // Green
        Stocks: "#66a9e4", // Yellow
        "National Pension Systems": "#6c757d", // Gray
        Bank: "#e8787d", // Red
        "Real Estates": "#9d53f2", // Orange
      },
    },

    resizable: true,
    legend: {
      //   alignment: 'center',
      position: "right",
    },
    pie: {
      labels: {
        enabled: false,
        formatter: () => void 0,
      },
    },
    donut: {
      width: "20px",
      center: {
        numberFormatter: formatCenterValue,
        label: "Total Net Worth",
      },
      alignment: "center",
    },
    height: "190px",
  };

  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }

  useEffect(() => {
    fetchNetworthGraph();
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex w-full h-[30vh] justify-center items-center">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div>
            <p className="text-[16px] font-semibold  ml-4 mt-[17px] mb-[10px]">
              All Users&#39; Net Worth Spectrum
            </p>
            <div className=" mt-0 pr-14  pb-[18px]">
              <DonutChart data={graphData} options={options}></DonutChart>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DonutChartCarbon;
